module.exports = __webpack_public_path__ + "static/img/instagram_white.e175f989.svg";